import { render } from "./HFDarkTemplate.vue?vue&type=template&id=769f4812&scoped=true"
import script from "./HFDarkTemplate.vue?vue&type=script&lang=js"
export * from "./HFDarkTemplate.vue?vue&type=script&lang=js"

import "./HFDarkTemplate.vue?vue&type=style&index=0&id=769f4812&scoped=true&lang=css"

import exportComponent from "C:\\onetap\\onetap\\frontend\\onetapuser\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-769f4812"]])

export default __exports__